export const commonOptions = {

    data() {
        return { 

            positionScheduleOptions: [
                { value: 'F', text: 'Full Time' },
                { value: 'P', text: 'Part Time' },
                { value: 'I', text: 'Intermittent'},    
            ],

            appointmentTypeOptions: [
                { value: 'P', text: 'Permanent' },
                { value: 'N', text: 'Non-Permanent' },
            ],
            
            positionClassificationOptions: [
                { value: 'C', text: 'Classified' },
                { value: 'U', text: 'Unclassified' },
            ],
            
            workTravelOptions: [
                { value: '1', text: 'None' },
                { value: '2', text: 'up to 25%' },
                { value: '3', text: 'up to 50%' },
                { value: '4', text: 'up to 75%' },
                { value: '5', text: 'up to 100%' },
            ],
            
            workScheduleOptions: [
                { value: '1', text: 'M-F FT reg hours' },
                { value: '2', text: 'M-F part time' },
                { value: '3', text: 'Other' },
                { value: '4', text: 'Day' },
                { value: '5', text: 'Afternoon' },
                { value: '6', text: 'Overnight' },
                { value: '7', text: 'Rotating' },
            ],

            flsaStatusOptions: [
                { value: 'E', text: 'Exempt' },
                { value: 'N', text: 'Non-Exempt' },            
            ],

            bargainingUnitOptions: [
                { value: 'M',  text: '214 - MAPE' },
                { value: 'AC', text: '206 - AFSCME Clerical' }, 
                { value: 'AT', text: '207 - AFSCME Technical' }, 
                { value: 'MA', text: '220 - Managerial' }, 
                { value: 'C',  text: "217 - Commissioner's Plan" },            
                { value: 'MN', text: '205 - MNA' }, 
                { value: 'MM', text: '216 - MMA' },
                { value: 'MG', text: '212 - MGEC' },            
                { value: 'MS', text: '221 - Medical Specialist' },            
                { value: 'IW', text: '218 - Insufficient Work Time' },            
            ],

            coopOptions: [
                { value: '1', text: 'Level 1' },
                { value: '2', text: 'Level 2' },
                { value: '3', text: 'Level 3' },
                { value: '4', text: 'Level 4' },            
            ],

            yesNoOptions: [
                { value: 'Y', text: 'Yes' },
                { value: 'N', text: 'No' },            
            ],

            yesNoUnknownOptions: [
                { value: 'Y', text: 'Yes' },
                { value: 'N', text: 'No' },
                { value: 'U', text: 'Unknown' },            
            ],

            leaveTypeOptions: [
                { value: 'COVID/EFMLA', text: 'COVID/EFMLA' },
                { value: 'FMLA', text: 'FMLA' },
                { value: 'Contractual', text: 'Contractual' },
                { value: 'Statutory', text: 'Statutory' },                
            ],

            workStatusOptions: [
                { value: 'Pending', text: 'Pending' },
                { value: 'FT Leave', text: 'FT Leave' },
                { value: 'PT Leave', text: 'PT Leave' },
            ],

            leaveDecisionOptions: [
                { value: 'Approved', text: 'Approved' },
                { value: 'Denied', text: 'Denied' },
                { value: 'Withdrawn', text: 'Withdrawn' },
            ],

            covidLeaveTypeOptions: [
                { value: 'Health', text: 'Health' },
                { value: 'Care', text: 'Care' },
                { value: 'School', text: 'School' },
            ],

            fmlaLeaveTypeOptions: [
                { value: 'Intermittent', text: 'Intermittent' },
                { value: 'Reduced Schedule', text: 'Reduced Schedule' },
                { value: 'Continuous', text: 'Continuous' },
            ],

            contractLeaveTypeOptions: [
                { value: 'Medical', text: 'Medical' },
                { value: 'Personal', text: 'Personal' },
                { value: 'Educational', text: 'Educational' },
                { value: 'Parenthood', text: 'Parenthood' },
            ],

            workRestrictionOptions: [
                { value: 'Y', text: 'Yes' },
                { value: 'N', text: 'No' },
            ],

            fmlaReasonsOptions: [
                { value: 'Birth/adoption', text: 'Birth/adoption' },
                { value: 'Minor child', text: 'Minor child' },
                { value: 'Adult child', text: 'Adult child' },
                { value: 'Military', text: 'Military' },
                { value: 'Parent', text: 'Parent' },
                { value: 'Self', text: 'Self' },
                { value: 'Spouse', text: 'Spouse' },
                { value: 'Foster care', text: 'Foster care' }
            ],

            sourceTypeOptions: [
                { value: null, text: ' ' },
                { value: 'STATE', text: 'STATE' },
                { value: 'REIMB', text: 'REIMB' },
            ],

            skillSetOptions: [
                { value: 'Admin support/office functions', text: 'Admin support/office functions' },
                { value: 'Call center experience', text: 'Call center experience' },
                { value: 'Communications', text: 'Communications' },
                { value: 'Community & social service support', text: 'Community & social service support' },
                { value: 'Customer service skills', text: 'Customer service skills' },                 
                { value: 'Data analytic skills', text: 'Data analytic skills' },
                { value: 'Data entry skills', text: 'Data entry skills' },
                { value: 'Employee development training', text: 'Employee development training' },
                { value: 'General labor skills', text: 'General labor skills' },
                { value: 'Graphic arts skills', text: 'Graphic arts skills' },
                { value: 'Healthcare experience', text: 'Healthcare experience' },
                { value: 'HR data system & transaction skills', text: 'HR data system & transaction skills' },
                { value: 'IT skills in applications , network, etc', text: 'IT skills in applications , network, etc' },
                { value: 'Social media skills', text: 'Social media skills' },
                { value: 'Supervisory skills', text: 'Supervisory skills' },
                { value: 'None required', text: 'None required' },
                { value: 'Other', text: 'Other' }    
            ],
            specialistTypeOptions:[
                { value: 'Staffing', text: 'Staffing' },
                { value: 'Payroll', text: 'Payroll' },
                { value: 'Delegate', text: 'Delegate' },
            ],
            rehireTimePeriodOptions:[
                {value: 'Over 4 years', text: "Over 4 years"},
                {value: 'Under 4 years"', text: "Under 4 years"},
            ],
            payrollOptions:[
                {value: 'NE', text: "New Employee"},
                {value: 'NSM', text: "New Supervisor/Manager"},
                {value: 'SP', text: "Split Pay"},
                {value: 'BP', text: "Backpay"},
            ],
            payrollActionCodes: {
                REV: {code: 38, description: 'Closeout Payroll Review'},
            },
            howPostedOptions:[
                { value: 'Statewide', text: 'Statewide' },
                { value: 'Competitive', text: 'Competitive' },
                { value: 'Agency Only', text: 'Agency Only' },
                { value: 'Non-Competitive', text: 'Non-Competitive' },
            ],
            separationTypeOptions: [
                { value: 'Retirement', text: 'Retirement' },
                { value: 'Separation', text: 'Separation' },
                { value: 'Transferring to another Agency', text: 'Transferring to another Agency'}
            ],
            hcrOptions: [
                { value: '$0.00', text: '$0.00' },
                { value: '$250.00', text: '$250.00' },
            ],
            searchScope: [
                { value: '1', text: 'Work In Progress Only' },
                { value: '2', text: 'Closed Only' },
                { value: '3', text: 'Cancelled Only' },
                { value: '4', text: 'All Requests' },
            ],
            payoutTypeOptions: [
                { value: 'Cash', text: 'Cash' },
                { value: 'Healthcare Saving Plan', text: 'Healthcare Saving Plan' },
            ],
            offerMethodOptions: [
                { value: 'Email', text: 'Email' },
                { value: 'Phone', text: 'Phone' },
                { value: 'In Person', text: 'In Person' },
                { value: 'Mail', text: 'Mail' },
            ],
            offerOutcomeOptions: [
                { value: 'Accept', text: 'Accept' },
                { value: 'Decline', text: 'Decline' },
            ],
            offerDeclineOptions: [
                { value: 'Salary too Low', text: 'Salary too Low' },
                { value: 'Processing too Long', text: 'Processing too Long' },
                { value: 'No Longer Interested', text: 'No Longer Interested' },
                { value: 'Other', text: 'Other' },
            ],
            offerNextStepsOptions: [
                { value: 'Begin Background Check', text: 'Begin Background Check' },
                { value: 'Offer to Another Candidate', text: 'Offer to Another Candidate' },
                { value: 'Repost', text: 'Repost' },
                { value: 'Other', text: 'Other' },
            ],
            reqRoles: [
                { value: 'hrm-requester', text: '*Requester' },
                { value: 'ffm-reviewer', text: 'FFM Reviewer' },
                { value: 'hrm-payroll', text: 'Payroll' },
                { value: 'hrm-transactions', text: 'Transactions' },
                { value: 'hrm-specialist', text: 'HRM Specialist' },
                { value: 'hrm-lead', text: 'HRM Lead' },
                { value: 'hrm-audit', text: 'Approver Audit Review' },
                { value: 'hrm-draft', text: 'Approver Post Draft Review' },
                { value: 'hrm-salary', text: 'Approver Salary Review' },
            ],
            roles: [
                { value: 'hrm-requester', text: '*Requester' },
                { value: 'ffm-reviewer', text: 'FFM Reviewer' },
                { value: 'hrm-payroll', text: 'Payroll' },
                { value: 'hrm-transactions', text: 'Transactions' },
                { value: 'hrm-specialist', text: 'HRM Specialist' },
                { value: 'hrm-lead', text: 'HRM Lead' },
                { value: 'hrm-audit', text: 'Approver Audit Review' },
                { value: 'hrm-draft', text: 'Approver Post Draft Review' },
                { value: 'hrm-salary', text: 'Approver Salary Review' },
                { value: 'hrm-leave', text: 'Leave Management' },
                { value: 'hrm-admin', text: 'Administrator' },
                { value: 'hrm-user-admin', text: 'User Administrator' },
            ]
        }
    }
}